import React, { useState, useEffect } from "react";
import styles from "./transactionDetailModal.module.css";
import modalCrossButton from "../../public/assets/modalCrossButton.svg";
import moment from "moment";
import { Spinner } from "react-bootstrap";
import {
  generateA2SignApi,
  getTransactionDetailUsingId,
  offlineSubmitTransaction,
  paymentLink,
  purposefetchData,
  statusApi,
} from "../../api";
import { useNavigate } from "react-router-dom";
import { useMyContext } from "../../myContext";
import InfoBox from "../../common/InfoBox/InfoBox";
import { addCommasInPrice, onOpenDocument } from "../../utils";
import XoticPartnerDetails from "./XoticPartnerDetails";

const TransactionDetailsModal = (props) => {
  const { stoTranId, onHide } = props;
  const [transactionDetails, setTransactionDetails] = useState();
  const [payNowClickedLoader, setPayNowCickLoader] = useState(false);
  const [a2SignLoader, setA2SignLoader] = useState(false);
  const [status, setPaymentStatus] = useState("");
  const [debitedFrom, setDebitedFrom] = useState("");
  const [creditedTo, setCreditedTo] = useState("");
  const [expiryDateTime, setExpiryDateTime] = useState("");
  const [timeDifference, setTimeDifference] = useState("");
  const {
    setListReuploadDocuments,
    redirectionLink,
    themeColor,
    partnerCode,
    offlineTransactionFlow,
    remitterStatus, // Stored in context for use across components
    setRemitterStatus,
    remitterId, // Stored in context for use across components
    setRemitterId,
  } = useMyContext();
  const [messageToShow, setMessageToShow] = useState("");
  const [loader, setLoader] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [utrLoader, setUtrLoader] = useState(false);
  const [utrNo, setUtrNo] = useState("");

  const navigate = useNavigate();

  function isNumber(num) {
    return typeof num === "number" && !isNaN(num);
  }

  function addCommasinPriceUS(price) {
    if (price && isNumber(price)) {
      return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return price;
  }

  const findTransactionDetails = () => {
    setMessageToShow("");
    getTransactionDetailUsingId(stoTranId)
      .then((response) => {
        if (response && response.status === 200) {
          sessionStorage.setItem(
            "studentId",
            response?.data?.transactionData?.studentId
          );
          if (
            response.data.transactionData &&
            response.data.transactionData.expiry
          )
            setExpiryDateTime(response.data.transactionData.expiry);
          setTransactionDetails(
            response.data ? response.data.transactionData : ""
          );
          setDebitedFrom(response.data.transactionData.debitedFrom);
          setCreditedTo(response.data.transactionData.creditedTo);
          setPaymentStatus(response.data.status);
          if (response.data.transactionData.status === "A2_E_SIGNED") {
            if (a2SignLoader) {
              setA2SignLoader(false);
              onHide();
            }
          }

          if (
            response.data.transactionData.status === "FUND_RECEIVED" ||
            response.data.transactionData.status === "FAILED" ||
            response.data.transactionData.status === "CANCELLED"||
            response.data.transactionData.status === "PROCESSED"
          ) {
            if (payNowClickedLoader === true) {
              setPayNowCickLoader(false);
              onHide();
            }
          }

          // Extract remitterId and call statusApi when DOCUMENTS_REJECTED
          // if (response.data.transactionData.status === "DOCUMENTS_REJECTED") {
            const extractedRemitterId = response.data.transactionData.remitterId;
            if (extractedRemitterId) {
              setRemitterId(extractedRemitterId);
              sessionStorage.setItem("remitterId", extractedRemitterId);
              // Fetch remitter status
              fetchRemitterStatus(extractedRemitterId);
            }
          // }

          fetchPurposeData(response.data.transactionData.purposeId);
        } else {
          if (response && response.message) {
            setMessageToShow(response.message);
          }
        }
      })
      .catch((err) => {});
  };

  const fetchRemitterStatus = async (remitterAccountId) => {
    try {
      const response = await statusApi(remitterAccountId);
      if (response && response.status === 200) {
        setRemitterStatus(response.data);
        console.log("Remitter Status:", response.data);
      }
    } catch (error) {
      console.error("Error fetching remitter status:", error);
    }
  };

  const fetchPurposeData = async (purposeId) => {
    setLoader(true);
    try {
      purposefetchData().then((response) => {
        setLoader(false);
        if (response && response.data) {
          sessionStorage.setItem("purpose", "Education");
          sessionStorage.setItem("purposeId", purposeId);
          const purpose = response?.data.find(
            (item) => item.title === "Education"
          );
          const subpurpose = purpose?.subPurpose.find(
            (item) => item.purposeId === purposeId
          );
          sessionStorage.setItem("subPurpose", subpurpose?.title);
        }
      });
    } catch (error) {
      setLoader(false);
    }
  };

  const date = new Date(
    transactionDetails ? transactionDetails.createdAt : null
  );

  const getModalDate = () => {
    if (date) {
      const newDate = date.toString("YYYY-MM-dd").split(" ");

      const finalDate = `${newDate[2]} ${newDate[1]} ${
        newDate[3] ? newDate[3].slice(-2) : null
      }`;
      const finalTime = `${
        newDate[4] ? moment(date).format("h:mm A z") : null
      }`;

      const ModalDate = `${finalDate} , ${finalTime} IST`;

      return ModalDate;
    }
  };

  useEffect(() => {
    if (offlineTransactionFlow === true) {
      setTransactionDetails(props.transactionItem);
      setLoader(false);
    } else {
      findTransactionDetails();
    }
  }, [stoTranId]);

  const uploadNowButton = (e) => {
    if (e === "QUOTE_INITIATED") {
      if (offlineTransactionFlow === true) {
        navigate("/offline-documents");
        sessionStorage.setItem("offlineUserStatus", "offlineDocuments");
        sessionStorage.setItem("offlineTransactionId", props.stoTranId);
        // sessionStorage.setItem("studentId", props.studentId);
        onHide();
      } else {
        navigate("/quote");
        sessionStorage.setItem("nextStep", "docUpload");
        sessionStorage.setItem("transactionID", props.stoTranId);
        onHide();
      }
    } else if (e === "HOLD") {
      navigate("/reuplod-document");
      sessionStorage.setItem("nextStep", "Reupload_Doc");
      sessionStorage.setItem("transactionID", props.stoTranId);
      setListReuploadDocuments(transactionDetails?.docReasons);
    }
  };

  const payNowClick = (e) => {
    if (e == "Verified") {
      generatePaymentLink();

      // confirmed  with roshan
    } else {
      window.open(transactionDetails.paymentLink, "_blank");
      setPayNowCickLoader(true);
      //  generatePaymentLink();
    }
  };

  const generateA2SIgnUrl = async () => {
    setA2SignLoader(true);
    let body = {
      transactionId: stoTranId,
       redirectUrl:redirectionLink
      // redirectUrl:"http://localhost:3000/redirecting",
    };
    try {
      const resp = await generateA2SignApi(body);
      if (resp.status === 200) {
        window.open(resp.data.esignUrl, "_blank");
      } else if (resp.status !== 200) {
        setA2SignLoader(false);
        setMessageToShow("Something went wrong, Please try again later.");
      }
    } catch (error) {
      setMessageToShow("Something went wrong, Please try again later.");
      setA2SignLoader(false);
    }
  };

  const generatePaymentLink = async () => {
    setMessageToShow("");
    setPayNowCickLoader(true);
    let body = {
      transactionId: stoTranId,
      redirectUrl: redirectionLink,
    };
    try {
      const resp = await paymentLink(body);
      if (resp.status === 500 || resp.status === 400) {
        setPayNowCickLoader(false);
        setMessageToShow("Something went wrong, Please try again later.");
        throw new Error("Payment link not found in response");
      } else if (
        resp.status === 200 &&
        resp.data.paymentLink &&
        resp !== undefined
      ) {
        window.open(resp.data.paymentLink, "_blank");
      } else {
        setPayNowCickLoader(false);
      }
    } catch (error) {
      setMessageToShow("Something went wrong, Please try again later.");
      setPayNowCickLoader(false);
    }
  };

  useEffect(() => {
    if (status !== "FUND_RECEIVED" && (payNowClickedLoader || a2SignLoader)) {
      var summaryInterval = setInterval(() => {
        findTransactionDetails();
      }, 10000);
    }
    return () => {
      clearInterval(summaryInterval);
    };
  }, [payNowClickedLoader, a2SignLoader]);

  const digitsAfterDecimal = (num) => {
    if (Number.isInteger(num)) {
      return `₹${addCommasInPrice(parseFloat(num))}`;
    }

    const arr = num.toString().split(".");
    if (arr[1].length === 1) {
      return `₹${addCommasInPrice(parseFloat(num))}0`;
    } else {
      return `₹${addCommasInPrice(parseFloat(num))}`;
    }
  };

  useEffect(() => {
    const calculateTimeDifference = () => {
      const expiryDate = new Date(expiryDateTime);
      const currentDate = new Date();

      const difference = expiryDate.getTime() - currentDate.getTime();
      const secondsDifference = Math.ceil(difference / 1000);

      const hours = Math.floor(secondsDifference / 3600);
      const remainingSeconds = secondsDifference % 3600;
      const minutes = Math.floor(remainingSeconds / 60);
      const seconds = remainingSeconds % 60;

      setTimeDifference(
        `${hours.toString().padStart(2, "0")}:${minutes
          .toString()
          .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`
      );
    };
    calculateTimeDifference();
    const interval = setInterval(calculateTimeDifference, 1000);
    return () => clearInterval(interval);
  }, [expiryDateTime]);

  const handleCompleteTransaction = async () => {
    setUtrLoader(true);
    try {
      const body = {
        transactionId: props.stoTranId,
        transactionRef: utrNo,
      };
      const resp = await offlineSubmitTransaction(body);
      setUtrLoader(false);
      if (resp?.status === 200) {
        navigate("/");
      } else {
        setErrorMessage(
          resp?.data?.message !== ""
            ? resp?.data?.message
            : "Something went wrong, please try again later"
        );
      }
    } catch (e) {
      setUtrLoader(false);
      setErrorMessage("Something went wrong, please try again later");
      setLoader(false);
    }
  };

  return (
    <div className={styles.modalContainer}>
      {transactionDetails ? (
        <div>
          <div
            className={styles.modalHeader}
            style={{
              backgroundColor: transactionDetails
                ? transactionDetails.status === "CREDITED"
                  ? "#0DC014"
                  : transactionDetails.status === "FUND_RECEIVED"
                  ? "#FFCA4B"
                  : transactionDetails.status === "COMPLETED"
                  ? "#0DC014"
                  : transactionDetails.status === "REJECTED"
                  ? "#FA274A"
                  : transactionDetails.status === "FAILED"
                  ? "#FA274A"
                  : transactionDetails.status === "CANCELLED"
                  ? "#FA274A"
                  : transactionDetails.status === "Quote_Declined"
                  ? "#FA274A"
                  : transactionDetails.status === "Initiated"
                  ? "#FFCA4B"
                  : transactionDetails.status === "WAITING_FOR_FUND" ||
                    transactionDetails.status === "Verified"
                  ? "#FFCA4B"
                  : transactionDetails.status === "HOLD" ||
                    transactionDetails.status === "DOCUMENTS_REJECTED"
                  ? "#FA5D05"
                  : transactionDetails.status === "QUOTE_INITIATED" ||
                    transactionDetails.status === "DOC_RECEIVED" ||
                    transactionDetails.status === "A2_E_SIGNED" ||
                    transactionDetails.status === "MANUAL_REVIEW"
                  ? "#FFCA4B"
                  : transactionDetails.status === "PENDING"
                  ? "#FFCA4B"
                  : transactionDetails.status === "PROCESSED"
                  ? "#FFCA4B"
                  : transactionDetails.status === "REFUNDED" ||
                    transactionDetails.status === "EXPIRED"
                  ? "#EFEFF1"
                  : ""
                : "",
            }}
          >
            <div className={styles.transactionStatus}>
              <p
                className={`${styles.status} ${styles.textWhite}`}
                style={{
                  color:
                    transactionDetails.status === "REFUNDED" ||
                    transactionDetails.status === "EXPIRED"
                      ? "#3C404A"
                      : "#FFFFFF",
                }}
              >
                {`${
                  transactionDetails
                    ? transactionDetails.status === "COMPLETED"
                      ? "Successful"
                      : transactionDetails.status === "FUND_RECEIVED"
                      ? "Processing"
                      : transactionDetails.status === "CREDITED"
                      ? "Successful"
                      : transactionDetails.status === "HOLD" ||
                        transactionDetails.status === "DOCUMENTS_REJECTED"
                      ? "On Hold"
                      : transactionDetails.status === "QUOTE_INITIATED" ||
                        transactionDetails.status === "DOC_RECEIVED" ||
                        transactionDetails.status === "A2_E_SIGNED" ||
                        transactionDetails.status === "MANUAL_REVIEW"
                      ? "Processing"
                      : transactionDetails.status === "PENDING"
                      ? "Processing"
                      : transactionDetails.status === "REJECTED"
                      ? "Rejected"
                      : transactionDetails.status === "Initiated"
                      ? "Processing"
                      : transactionDetails.status === "REFUNDED"
                      ? "Refunded"
                      : transactionDetails.status === "FAILED"
                      ? "Failed"
                      : transactionDetails.status === "CANCELLED"
                      ? "Failed"
                      : transactionDetails.status === "Quote_Declined"
                      ? "Failed"
                      : transactionDetails.status === "PROCESSED"
                      ? "Processing"
                      : transactionDetails.status === "EXPIRED"
                      ? "Expired"
                      : transactionDetails.status === "WAITING_FOR_FUND" ||
                        transactionDetails.status === "Verified"
                      ? "Processing"
                      : "--"
                    : "--"
                }`}
                {transactionDetails ? (
                  transactionDetails.status === "QUOTE_INITIATED" ||
                  transactionDetails.status === "REJECTED" ? (
                    <span style={{ marginLeft: "5px" }}>
                      <InfoBox
                        content={transactionDetails?.statusReason}
                        color={"white"}
                      />
                    </span>
                  ) : null
                ) : null}
              </p>
              <p
                className={`${styles.modalText} ${styles.textWhite}`}
                style={{
                  color:
                    transactionDetails.status === "REFUNDED" ||
                    transactionDetails.status === "EXPIRED"
                      ? "#3C404A"
                      : "#FFFFFF",
                  fontSize: "14px",
                }}
              >
                {transactionDetails &&
                transactionDetails.tranStatus === "COMPLETED"
                  ? "This may take upto 3 working days."
                  : getModalDate()}
              </p>
            </div>
            <img
              src={modalCrossButton}
              alt="cross-button"
              onClick={() => {
                onHide();
              }}
            ></img>
          </div>
          {payNowClickedLoader || a2SignLoader ? (
            <div
              style={{
                textAlign: "center",
                height: "150px",
                paddingTop: "60px",
              }}
            >
              <Spinner
                animation="border"
                className={styles.spinnerColor}
                // style={{ color: "#0061d3"}}
                style={{ borderColor: themeColor, borderRightColor: "#eaecf0" }}
              />
            </div>
          ) : (
            <>
              {transactionDetails.status === "FUND_RECEIVED" ? (
                <div className={styles.transactionNotifier}>
                  <p className={styles.statementText}>Fund Recevied</p>
                  {/* <p className={styles.uploadButton}>
                   
                  </p> */}
                </div>
              ) : transactionDetails.status === "QUOTE_INITIATED" ? (
                <div className={styles.transactionNotifier}>
                  <p className={styles.statementText}>Upload Documents</p>
                  {loader === false && (
                    <p
                      className={styles.uploadButton}
                      onClick={() => uploadNowButton("QUOTE_INITIATED")}
                    >
                      Upload Now
                    </p>
                  )}
                </div>
              ) : transactionDetails.status === "DOC_RECEIVED" ? (
                offlineTransactionFlow === true ? (
                  ""
                ) : (
                  <div className={styles.transactionNotifier}>
                    {messageToShow !== "" ? (
                      <p className={styles.errorMessage}>{messageToShow}</p>
                    ) : (
                      <>
                        <p className={styles.statementText}></p>
                        <p
                          className={styles.uploadButton}
                          onClick={() => generateA2SIgnUrl("DOC_RECEIVED")}
                        >
                          Complete A2 Sign
                        </p>
                      </>
                    )}
                  </div>
                )
              ) : transactionDetails.status === "A2_E_SIGNED" ? (
                messageToShow !== "" && (
                  <div className={styles.transactionNotifier}>
                    <p className={styles.errorMessage}>{messageToShow}</p>
                  </div>

                  //  // <>
                  //   <p className={styles.statementText}>Complete Payment</p>
                  //   <p
                  //     className={styles.uploadButton}
                  //     onClick={() => payNowClick("DOC_RECEIVED")}
                  //   >
                  //     Pay Now
                  //   </p>
                  // </>
                )
              ) : transactionDetails.status === "MANUAL_REVIEW" ? (
                <div className={styles.transactionNotifier}>
                  {messageToShow !== "" ? (
                    <p className={styles.errorMessage}>{messageToShow}</p>
                  ) : (
                    <>
                      <p className={styles.statementText}>
                        Documents are under review
                      </p>
                    </>
                  )}
                </div>
              ) : transactionDetails.status === "WAITING_FOR_FUND" ||
                transactionDetails.status === "Verified" ? (
                <div className={styles.transactionNotifier}>
                  {messageToShow !== "" ? (
                    <p className={styles.errorMessage}>{messageToShow}</p>
                  ) : (
                    <>
                      <p className={styles.statementText}>Complete Transfer</p>
                      <p
                        className={styles.uploadButton}
                        onClick={() => payNowClick("Verified")}
                      >
                        Pay Now
                      </p>{" "}
                    </>
                  )}
                </div>
              ) : transactionDetails.status === "HOLD" ||
                transactionDetails.status === "DOCUMENTS_REJECTED" ? (
                <div className={styles.transactionNotifier}>
                  <p className={styles.statementText}>
                    Upload Documents{" "}
                    <InfoBox content={transactionDetails?.statusReason} />
                  </p>
                  {loader === false && (
                    <p
                      className={styles.uploadButton}
                      onClick={() => uploadNowButton("HOLD")}
                    >
                      Upload Now
                    </p>
                  )}
                </div>
              ) : transactionDetails.status === "COMPLETED" &&
                offlineTransactionFlow === false ? (
                <div className={`${styles.transactionNotifier}`}>
                  <p className={styles.statementText}>Download SWIFT Copy</p>
                  <p
                    className={styles.uploadButton}
                    onClick={() =>
                      onOpenDocument(transactionDetails.swiftDocUrl, true)
                    }
                  >
                    Download
                  </p>
                </div>
              ) : (
                ""
              )}
              <div className={styles.transactionInfo}>
                <p
                  className={`${styles.modalText} ${styles.textGrey}`}
                  style={{ color: "#767C8F" }}
                >
                  Transfer Funds
                </p>
                {transactionDetails &&
                transactionDetails.tranStatus === "settled" ? (
                  <p className={`${styles.amount} ${styles.textBlack}`}>
                    <span>
                      {transactionDetails &&
                      transactionDetails.tranType === "debit"
                        ? "-"
                        : "+"}
                    </span>
                    {transactionDetails
                      ? `$${addCommasinPriceUS(
                          parseFloat(transactionDetails.amount)
                        )}`
                      : ""}
                  </p>
                ) : (
                  <p className={`${styles.amount} ${styles.textBlack}`}>
                    {transactionDetails
                      ? `₹${addCommasInPrice(
                          parseFloat(transactionDetails.amount)
                        )}`
                      : ""}
                  </p>
                )}
                {offlineTransactionFlow === false &&
                  (transactionDetails.status === "QUOTE_INITIATED" ||
                    transactionDetails.status === "DOC_RECEIVED" ||
                    transactionDetails.status === "DOC_RECEIVED" ||
                    transactionDetails.status === "A2_E_SIGNED" ||
                    transactionDetails.status === "WAITING_FOR_FUND" ||
                    transactionDetails.status === "HOLD" ||
                    transactionDetails.status === "DOCUMENTS_REJECTED") && (
                    <>
                      {timeDifference !== "" && timeDifference > "00:00:00" ? (
                        <p className={styles.expiresdivspan}>
                          Expires in {timeDifference}
                        </p>
                      ) : (
                        ""
                      )}
                    </>
                  )}
              </div>
            </>
          )}
          {offlineTransactionFlow === true ? (
            <XoticPartnerDetails
              transactionDetails={transactionDetails}
              status={transactionDetails?.status}
              setUtrNo={setUtrNo}
            />
          ) : (
            <div className={styles.transactionDetails}>
              <hr className={styles.divider} />

              <div className={styles.modalRow}>
                <p className={` ${styles.modalText} ${styles.textGrey}`}>
                  Transaction ID
                </p>
                <div className={` ${styles.modalRow} ${styles.modalRowInfo}`}>
                  <p className={` ${styles.modalText} ${styles.textBlack}`}>
                    {transactionDetails
                      ? transactionDetails.transactionId
                        ? transactionDetails.transactionId.length > 30
                          ? `${transactionDetails.transactionId.substring(
                              0,
                              25
                            )}...`
                          : transactionDetails.transactionId
                        : "--"
                      : "--"}
                  </p>
                </div>
              </div>
              <div className={styles.modalRow}>
                <p className={` ${styles.modalText} ${styles.textGrey}`}>
                  Debited From
                </p>
                <div className={` ${styles.modalRow} ${styles.modalRowInfo}`}>
                  <p className={` ${styles.modalText} ${styles.textBlack}`}>
                    {debitedFrom ? debitedFrom : "--"}
                  </p>
                </div>
              </div>

              <div className={styles.modalRow}>
                <p className={` ${styles.modalText} ${styles.textGrey}`}>
                  Credited To
                </p>
                <div className={` ${styles.modalRow} ${styles.modalRowInfo}`}>
                  <p className={` ${styles.modalText} ${styles.textBlack}`}>
                    {creditedTo ? creditedTo : "--"}
                  </p>
                </div>
              </div>

              <div className={styles.modalRow}>
                <p className={` ${styles.modalText} ${styles.textGrey}`}>
                  Transaction Charges
                </p>
                <div className={` ${styles.modalRow} ${styles.modalRowInfo}`}>
                  <p className={` ${styles.modalText} ${styles.textBlack}`}>
                    {transactionDetails
                      ? transactionDetails.transactionCharges
                        ? digitsAfterDecimal(
                            transactionDetails.transactionCharges
                          )
                        : "--"
                      : "--"}
                  </p>
                </div>
              </div>
            </div>
          )}
          {errorMessage !== "" && (
            <div className={styles.errorState}>{errorMessage}</div>
          )}
          <div className={`${styles.modalRow} ${styles.modalButtonContainer}`}>
            {transactionDetails.status === "Initiated" &&
            offlineTransactionFlow === true ? (
              <>
                <button
                  className={`${styles.modalButton} ${styles.modalButtonBlue}`}
                  style={{
                    width: "100%",
                    background: "#FFCA4B",
                    borderColor: "#FFCA4B",
                  }}
                  onClick={handleCompleteTransaction}
                >
                  <p className={styles.modalText} style={{ color: "white" }}>
                    {utrLoader && (
                      <Spinner
                        animation="border"
                        className={styles.spinnerColor}
                        style={{
                          borderColor: "#FFCA4B",
                          borderRightColor: "white",
                        }}
                      />
                    )}{" "}
                    Submit
                  </p>
                </button>
              </>
            ) : (
              <a
                href="mailto:customersuccess@stockal.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{ width: "100%" }}
              >
                <button
                  className={`${styles.modalButton} ${styles.modalButtonBlue}`}
                  style={{ width: "100%", borderColor: themeColor }}
                >
                  <p className={styles.modalText} style={{ color: themeColor }}>
                    Contact Support
                  </p>
                </button>
              </a>
            )}
          </div>
        </div>
      ) : (
        <div className={styles.spinnerbody}>
          <Spinner
            animation="border"
            className={styles.spinnerColor}
            // style={{ color: "#0061d3"}}
            style={{ borderColor: themeColor, borderRightColor: "#eaecf0" }}
          />
        </div>
      )}
    </div>
  );
};

export default TransactionDetailsModal;
